import '../../App.css';
import MusicTherapyRates from "../Resources/Music-Therapy-Rates.pdf"
import MusicLessonRates from "../Resources/Music-Lesson-Rates.pdf"
import GroupEventRates from "../Resources/Event-Rates.pdf"
//TODO: implement RateSheetButton with params instead of hardcoded
//import RateSheetButton from "../RateSheetButton";

function RateSheets() {
    return (
        <div className="rate-sheet-section">
            <h2>Ready to schedule?</h2>
            <a className="intake-form-button button-styles" href="https://forms.gle/kJwxvDrSUUdJ2Rcr5" target="_blank" rel="noreferrer">Intake Form</a>

            <p className="general-text">View rate sheets for various services provided.</p>
            <div className="rate-sheet-buttons-container">
                <a className="rate-sheet-button button-styles" href={MusicTherapyRates} target="_blank" rel="noreferrer">Music Therapy</a>
                <a className="rate-sheet-button button-styles" href={MusicLessonRates} target="_blank" rel="noreferrer">Music Lessons</a>
                <a className="rate-sheet-button button-styles" href={GroupEventRates} target="_blank" rel="noreferrer">Group Events</a>
            </div>
            <p className="general-text rate-sheet-text">Ms. Allison believes in transparency and equity as fundamental values. Every circumstance is different from the next, so please don't hesitate to reach out with questions or concerns directly at allison@allisonnocita.com</p>
        </div>
    )
}

export default RateSheets;
